/**
 * Creates one detached element in the standard SVG namespace.
 *
 * @param tagName SVG tag selected from the browser's typed SVG element map.
 * @returns Newly created SVG element with the exact type corresponding to `tagName`.
 */
export function createSvgElement<K extends keyof SVGElementTagNameMap>(
  tagName: K,
): SVGElementTagNameMap[K] {
  return document.createElementNS('http://www.w3.org/2000/svg', tagName);
}
